import React, { useState } from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
} from "client/components"

import Type from "./type"
import { ContainerStyled, Title } from "../styled"

const TYPE = "#type"

const CcReview = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const menu = [
        { key: TYPE, title: lang.itemType },
    ]

    const [activeTab, setActiveTab] = useState(TYPE)

    return (
        <ContainerStyled>
            <Title>{lang.reviewSettings}</Title>
            <PageContent>
                <PageMenu>
                    {
                        menu.map((menuRow) => (
                            <PageMenuButton
                                key={menuRow.key}
                                isActive={activeTab === menuRow.key}
                                onClick={() => setActiveTab(menuRow.key)}
                            >
                                {menuRow.title}
                            </PageMenuButton>
                        ))
                    }
                </PageMenu>

                <Tab show={activeTab === TYPE}>
                    <Type />
                </Tab>
            </PageContent>
        </ContainerStyled>
    )
}
export default CcReview
